<div class="input-group">
  <label>RULE NAME:</label>
  <input type="text" [(ngModel)]="rule.name" />
</div>

<div class="input-group">
  <label>RULE COLOR INDICATION:</label>
  <div class="choose-color-input">
    <div
      class="color-item"
      *ngFor="let color of colors; let index = index"
      [style.background-color]="color"
      [class.selected]="this.rule.color - 1 === index"
      (click)="onRuleColorSelected(index+1)"
    ></div>
  </div>
</div>
